// Tracks whether an uncommitted AI community draft is in progress, so navigation
// can warn before discarding it. Module-level singleton — only one draft can be
// open at a time (the setup wizard and the dashboard tab never mount together).
let dirty = false;

export const draftGuard = {
  set: (v) => {
    dirty = !!v;
  },
  isDirty: () => dirty,
};
